import { Controller, useForm } from "react-hook-form";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Label } from "../../../components/Label/Label";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import routePaths from "../../../Navigation/routePaths";
import { permissionsInterface } from "../../onBoarding/onBoardingTypes";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import WebService from "../../../utility/WebService";
import Select from "react-select";
import { decrypt } from "../../../utility/cryptoUtils";
import { toast } from "react-toastify";
import UploadFile from "../../../components/UploadFile/UploadFile";
import { IoClose } from "react-icons/io5";
import DocIcon from "../../../assets/images/doc-icon.svg";
import PlotDatePicker from "../../../components/PlotDatePicker/PlotDatePicker";



const CreateReceipt = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { handleSubmit, formState: { errors, isValid }, control, watch, register, reset, setValue, } = useForm<any>({});
  const watchAllFields = watch();
  const { id }: any = useParams();
  const [bookingDetail, setBookingDetail] = useState<any>({});
  const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
  const [pressedKeys, setPressedKeys] = useState(new Set());
  const [formLoading, setFormLoading] = useState<boolean>(true);
  const isEdit = window.location.pathname === routePaths.RECEIPT_UPDATE.path + id;
  const isShowHiddenFields = state?.type ?? false;
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [cashPaidAmount, setCashPaidAmount] = useState<number>(0);


  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "RECEIPTS"));
    }
  }, [token]);

  useEffect(() => {
    if (permissions && permissions.can_read) {
      if (window.location.pathname === "/update-receipt/" + id && permissions.can_update) {
        isShowHiddenFields == "REAL" ? setShowHiddenFields(true) : setShowHiddenFields(false);
        getDetail(isShowHiddenFields == "REAL" ? true : false);
      } else if (permissions.can_write && id) {
        resetForm();
        setFormLoading(false);
        getBookingDetail();
        setValue('created_at', new Date());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [pressedKeys]);

  useEffect(() => {
    if (showHiddenFields) {
      getBookingDetail(true);
    }
  }, [showHiddenFields]);

  const paymentOptions = [
    { value: "ONLINE", label: "Online" },
    { value: "CHEQUE", label: "Cheque" },
    { value: "CASH", label: "Cash" },
  ];

  const resetForm = () => { setValue("total_cost", ""); };

  const getBookingDetail = (fieldFlag?: boolean) => {
    WebService.getAPI({ action: `booking/detail/${window.location.pathname !== "/update-receipt/" + id ? id : watch("booking_uuid")}`, is_session: fieldFlag ?? showHiddenFields })
      .then((res: any) => {
        onSelectBooking(res.booking);
        setCashPaidAmount(res.sumOfPaymentByCash);
        setBookingDetail(res.booking);
      })
      .catch((e: any) => { });
  };

  const getDetail = (fieldFlag: boolean) => {
    WebService.getAPI({ action: `receipt/detail/${id}`, is_session: fieldFlag })
      .then((res: any) => {
        if (res.result) {
          reset(res.result);
          setValue("customer_name", res.result?.customer_name);
          setValue("customer_phone", res.result?.customer_phone);
          setValue("total_cost", res.result?.total_cost);
          setValue("booking_uuid", res.result?.booking_uuid);
          setFormLoading(false);
          getBookingDetail(fieldFlag);
        }
      })
      .catch((e: any) => { navigate(routePaths.RECEIPT.path); });
  };

  const onSubmit = (data: any) => {
    if (!data.file_name) { toast.error("Please upload receipt file"); return; }
    if (!showHiddenFields && data.payment_mode === "CASH" && (data.paying_amount > 10000 || cashPaidAmount >= 10000 || (Number(cashPaidAmount) + Number(data.paying_amount)) > 10000)) {
      toast.error("For cash payment, the maximum allowed amount is 10,000.");
      return;
    }
    // data.paying_amount = (Number(data.paying_amount) / Number(data.rateValue)).toFixed(2);
    if (window.location.pathname === "/update-receipt/" + id) {
      WebService.putAPI({ action: "receipt/update", body: data, id: "receipt_create_update_btn", is_session: showHiddenFields })
        .then((res: any) => { navigate(routePaths.RECEIPT.path + "?booking=" + watchAllFields.booking_uuid); })
        .catch((e) => { });
    } else {
      WebService.postAPI({ action: "receipt/create", body: data, id: "receipt_create_update_btn", is_session: showHiddenFields })
        .then(async (res: any) => {
          navigate(routePaths.RECEIPT.path + "?booking=" + res.booking_id);
        }).catch((e) => { });
    }
  };

  const onSelectBooking = (e: any) => {
    if (e) {
      setValue("booking_id", e.id);
      setValue("referral_code", e.referral_code);
      setValue("discount_code", e.discount_code);
      if (showHiddenFields) {
        setValue("due_amount", Number(decrypt(e.referral_code)) - Number(decrypt(e.discount_code)));
        setValue("paid_amount", Number(decrypt(e.discount_code)));
        setValue("total_cost", Number(decrypt(e.referral_code)));
      } else {
        setValue("due_amount", Number(e.total_cost) - Number(e.paid_amount));
        setValue("paid_amount", Number(e.paid_amount));
        setValue("total_cost", e.total_cost);
      };
      setValue("customer_name", e.customer_name);
      setValue("customer_phone", e.customer_phone);
    }
  };

  const handleKeyDown = (e: any) => {
    const key = e.key ? e.key.toLowerCase() : "";
    setPressedKeys((prev: any) => new Set([...prev, key]));
  };

  const handleKeyUp = (e: any) => {
    const key = e.key ? e.key.toLowerCase() : "";
    // Check for ctrl+p+t
    if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) {
      if (isEdit) {
        if (isShowHiddenFields === "REAL") {
          setShowHiddenFields(true);
        }
      } else {
        setShowHiddenFields(true);
      }
    }
    // Remove the key from the set
    setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
  };

  const onUploadFile = (data: any, name: string, size: string) => {
    const blob = URL.createObjectURL(data);
    var isImageExte = /(\.(jpg|jpeg|png))$/i;
    var isVideo = /(\.(mp4))$/i;
    var isPdf = /(\.(pdf))$/i;
    let type = "";

    if (isImageExte.test(name)) {
      type = "IMAGE";
    } else if (isVideo.test(name)) {
      type = "VIDEO";
    } else if (isPdf.test(name)) {
      type = "PDF";
    }
    uploadFile(data);
  };

  const uploadFile = async (data: any) => {
    WebService.fileUploadAPI({ action: `upload/file`, key: "image", file: data, body: { type: "RECEIPTS" }, id: "receipt_create_update_btn" })
      .then(async (res: any) => {
        toast.success("File uploaded successfully");
        setValue("file_name", res.file_name);
      })
      .catch(async (error: any) => { });
  };

  const onDeleteImage = () => {
    setValue("file_name", "")
  };

  const getSignedUrl = (fileName: string) => {
    WebService.postAPI({ action: "get/signed-url", body: { key: `receipts/${fileName}` } })
      .then((res: any) => {
        if (res && res.signed_url) {
          window.open(res.signed_url, "_blank");
        } else {
          toast.error("Failed to get signed URL");
        }
      })
      .catch((error: any) => { toast.error("Failed to get signed URL"); });
  };


  return (
    <div className="app-page page-dashboard">
      <div className="d-flex justify-content-between align-items-center ">
        <PageTitle
          title={
            window.location.pathname === "/update-receipt/" + id
              ? "Edit Receipt"
              : "Add Receipt"
          }
          backArrow={true}
          active={showHiddenFields}
        />
      </div>
      {permissions && (permissions.can_update || permissions.can_write) && <Card style={{ height: '100%' }}>
        <Card.Body>
          <form className=" form-style" onSubmit={handleSubmit(onSubmit)}>
            {watch().customer_name && watch().customer_phone && (
              <Row>
                <Col lg={2}>
                  <Form.Group>
                    <Form.Label>Booking ID :-</Form.Label>
                    {"  "}
                    {bookingDetail?.book_id}
                  </Form.Group>
                </Col>
                <Col lg={2}>
                  <Form.Group>
                    <Form.Label>Customer name :-</Form.Label>
                    {"  "}
                    {watch().customer_name}
                  </Form.Group>
                </Col>
                <Col lg={2}>
                  <Form.Group>
                    <Form.Label>Customer phone :-</Form.Label>{" "}
                    {watch().customer_phone}
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  {bookingDetail && bookingDetail.project_units && bookingDetail.project_units.length > 0 && <div className="mb-3 d-flex align-items-center gap-2">
                    <p className="mb-1 font-medium">Units:</p>
                    <div className="selected-unit-list">
                      <span>  <strong>{bookingDetail.project_units.map((item: any) => {
                        return item.unit_name;
                      }).join(", ")}</strong> </span>
                    </div>
                  </div>}
                </Col>
              </Row>
            )}

            {!formLoading && <Row>
              <Col lg={6}>
                {/* Total Amount and Paying Amount */}
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Total Amount</Form.Label>
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1 mt-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Total Amount"
                          disabled
                          value={watch().total_cost}
                          {...register("total_cost", { required: true })}
                        />
                      </div>
                      {errors.total_cost && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please enter comment"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Paying Amount</Form.Label>
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Paying Amount"
                          {...register("paying_amount", { required: true })} //, min: 1
                        // onKeyPress={HelperService.allowOnlyNumericValue}
                        />
                      </div>
                      {errors.paying_amount && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please enter paying amount"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Due Amount</Form.Label>
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Due Amount"
                          disabled
                          value={watch().due_amount}
                          {...register("due_amount", { required: true })} //, min: 1
                        // onKeyPress={HelperService.allowOnlyNumericValue}
                        />
                      </div>
                      {errors.due_amount && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please enter paying amount"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Paid Amount</Form.Label>
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1 mt-1">
                        <input
                          disabled
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Paid Amount"
                          value={watch().paid_amount}
                          {...register("paid_amount", { required: true })}
                        />
                      </div>
                      {errors.paid_amount && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please enter paid amount"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  {!watchAllFields.file_name && <UploadFile
                    key={new Date().getTime()}
                    onChange={(data: any, name: string, size: string) => { onUploadFile(data, name, size); }}
                    acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                    message="Upload or Drag and Drop Receipt here"
                    acceptedSize={5}
                  />}

                  {(watchAllFields.file_name) && <Card className={`border p-2 d-inline-block px-3 mb-3 me-2 h-auto`}>
                    <div className="d-flex gap-3 align-items-center">
                      <div className="me-1">
                        <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                      </div>
                      <div><img src={DocIcon} width={40} height={40} alt="" /></div>
                      <div>
                        <p className="font-medium font-16 mb-0 cursor-pointer" onClick={() => getSignedUrl(watchAllFields.file_name)}>{watchAllFields.file_name}</p>
                      </div>
                    </div>
                  </Card>}
                </Row>
              </Col>

              <Col lg={6}>

                <Row>
                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="payment_mode"
                      rules={{
                        required: true,
                      }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Payment Mode</Form.Label>
                          <span className="text-danger">*</span>
                          <Select
                            options={paymentOptions}
                            onChange={(e: any) => {
                              onChange(e.value);
                            }}
                            value={paymentOptions.find(
                              (_: any) => _.value == watchAllFields.payment_mode
                            )}
                          />
                          {errors.payment_mode && (
                            <div className="login-error mb-3">
                              <Label
                                title={"Please select payment mode"}
                                modeError={true}
                              />
                            </div>
                          )}
                        </Form.Group>
                      )}
                    />
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Receipt Number</Form.Label>
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input type="text" className="form-control ps-3 p-2" placeholder="Receipt Number" {...register("receipt_id", { required: true })} />
                      </div>
                      {errors.receipt_id && (<div className="login-error mb-3">  <Label title={"Please enter receipt number"} modeError={true} /> </div>)}
                    </Form.Group>
                  </Col>
                </Row>
                <Col lg={6}>
                  <Controller
                    control={control}
                    name="created_at"
                    rules={{ required: true, }}
                    render={({ field: { onChange } }) => (
                      <Form.Group className="mb-3">
                        <Form.Label>Receipt Date</Form.Label>
                        <span className="text-danger">*</span>
                        <div className="input-group mb-1">
                          <div className="col-12 form-group">
                            <PlotDatePicker
                              selected={watch("created_at") ? new Date(watch("created_at")) : null}
                              onChange={(date: any) => onChange(date)}
                              placeholderText="Select Date"
                            />
                            {errors.created_at && (<Label title={"Please Select Receipt Date."} modeError={true} />)}
                          </div>
                        </div>
                      </Form.Group>
                    )}
                  />
                </Col>

                <Form.Group className="mb-3">
                  <Form.Label>Comment</Form.Label>
                  {/* <span className="text-danger">*</span> */}
                  <div className="input-group mb-1 mt-1">
                    <textarea
                      rows={4}
                      className="form-control ps-3 p-2"
                      placeholder="Comment"
                      value={watch().comment}
                      {...register("comment", { required: false })}
                    />
                  </div>
                  {/* {errors.comment && (
                    <div className="login-error mb-3">
                      <Label title={"Please enter comment"} modeError={true} />
                    </div>
                  )} */}
                </Form.Group>
                {bookingDetail && bookingDetail.project_units && bookingDetail.project_units.length > 0 && <div className="mb-3">
                  <p className="mb-1 font-14 font-medium">Registration Power:</p>
                  <ul className="selected-unit-list">
                    {bookingDetail.project_units.map((item: any) => (
                      <li key={item.value}>{item.unit_name} - <strong>{item.registration_power}</strong>   and area is {item.area} sq ft and {item.is_mortgage ? "Mortgage" : "No Mortgage"}<br />
                        {item.comment ? `Comment: ${item.comment}` : ""}
                      </li>
                    ))}
                  </ul>
                </div>}
              </Col>
              <Col lg={3}></Col>
              <Col lg={6} className="text-center">
                <Button className="btn-brand-1 me-3 w-50 mt-3" disabled={!isValid} type="submit" id="receipt_create_update_btn">
                  {window.location.pathname === "/update-receipt/" + id ? "Update" : "Save"}
                </Button>
              </Col>
            </Row>}
          </form>

          {/* {showHiddenFields &&
            <form className=" form-style" onSubmit={handleSubmit1(onSubmitCalculateAmount)}>
              <Row>
                <Col lg={3}>
                  <Form.Group>
                    <Form.Label>Real Total Amount :-</Form.Label>
                    {"  "}
                    {watch1().real_total_amount}
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group>
                    <Form.Label>Real Due Amount :-</Form.Label>{" "}
                    {watch1().real_due_amount}
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group>
                    <Form.Label>Real Paid Amount :-</Form.Label>{" "}
                    {watch1().real_paid_amount}
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <div className="d-flex">
                  <div className="input-group mb-1 mt-1 w-25">
                    <input
                      type="text"
                      className="form-control ps-3 p-2 w-50"
                      placeholder="Amount"
                      value={watch1().amount}
                      {...register1("amount", { required: true, pattern: /^[0-9]+(\.[0-9]{1,2})?$/ })}
                    />
                  </div>
                  <Button
                    className="btn-brand-1 ms-3 mt-1"
                    disabled={!isValid1}
                    type="submit"
                    id="receipt_create_update_btn"
                  >
                    Calculate
                  </Button>
                </div>
              </Form.Group>
            </form>} */}
        </Card.Body>
      </Card>}
    </div >
  );
};

// const mapDispatchToProps = (dispatch: any) => ({
//     onSubmit: (params: ProjectUnitInterface) => dispatch(projectUnitCreateRequest(params)),
// });

export default CreateReceipt; //connect(null, mapDispatchToProps)
